<panel-widget icon="fa-unlock-alt" [title]="'Desbloqueo temporal'">
  <div class="unlock-panel col-md-6">
    <div class="button-box">
      <ng-container *ngIf="person.isTemporarilyUnlocked; else unlockButton">
        <button
          *ngIf="timeRemaining"
          class="btn btn-danger btn-sm"
          (click)="unlockModal.show()"
          [disabled]="!canUnlockTemporarily()">
          <i class="fa fa-clock"></i>
          {{ 'Desbloqueado por ' + timeRemaining }}
        </button>
      </ng-container>
      <ng-template #unlockButton>
        <button
          authorizedElement
          [authElementCode]="19505"
          authElementName="ML_BTN_UNLOCK_TEMP"
          class="btn btn-danger btn-sm"
          (click)="unlockModal.show()"
          [disabled]="!canUnlockTemporarily()">
          Desbloquear temporalmente
        </button>
      </ng-template>
    </div>
    <div
      authorizedElement
      [authElementCode]="19505"
      authElementName="ML_BTN_UNLOCK_TEMP"
      class="show-more-box col-md-6"
      *ngIf="person.isTemporarilyUnlocked">
      <link-show-more [label]="'Ver razón del desbloqueo'">
        <div class="show-more-content">
          <textarea rows="5" [disabled]="true">
            {{ person.unlockReason || '' }}
          </textarea>
        </div>
      </link-show-more>
    </div>
  </div>
</panel-widget>
<div
  bsModal
  #unlockModal="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
  (onHidden)="unlockModal.hide()">
  <div class="modal-dialog modal-xs">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          (click)="unlockModal.hide()"
          aria-label="Close">
          >
          <span aria-hidden="false">&times;</span>
        </button>
        <h4 class="modal-title">Confirmación</h4>
      </div>
      <div class="modal-body overflow-hidden">
        <loader-view [show]="loading"></loader-view>
        <div *ngIf="!loading">
          <div *ngIf="!person.isTemporarilyUnlocked; else labelBlock">
            <h3 style="padding: 0px 0px 2rem 1.6rem">
              {{
                showFieldDate
                  ? ('mlUnlockTemporarilyComponent_UNLOCK_TEXT' | i18n)
                  : ('mlUnlockTemporarilyComponent_UNLOCK_TEXT_THREE_HOURS'
                    | i18n)
              }}
            </h3>
            <form [formGroup]="reactiveForm" class="smart-form">
              <div class="col-xs-12">
                <div class="checkbox-group">
                  <input
                    id="showFieldDate"
                    type="checkbox"
                    (change)="showFieldDate = !showFieldDate" />
                  <label for="showFieldDate" style="padding: 0 0 1rem 0.5rem">
                    {{ 'Desbloquear por fecha especifica' }}
                  </label>
                </div>
              </div>
              <div class="col-xs-12" *ngIf="showFieldDate">
                <div class="form-group">
                  <label class="">
                    {{ 'INPUT_LABEL_FECHA_SOLICITUD' | i18n }}:
                    <span class="tl span-required" title="CAMPO OBLIGATORIO">
                      (*)
                    </span>
                  </label>
                  <input
                    name="temporaryUnlockedUntil"
                    type="datetime-local"
                    class="form-control w-full"
                    formControlName="temporaryUnlockedUntil"
                    [attr.min]="minDate"
                    [attr.max]="maxDate"
                    (change)="validateDate($event.target.value)" />
                  <div
                    *ngIf="
                      reactiveForm.get('temporaryUnlockedUntil').invalid &&
                      reactiveForm.get('temporaryUnlockedUntil').touched
                    ">
                    <div
                      *ngIf="
                        reactiveForm
                          .get('temporaryUnlockedUntil')
                          .hasError('required')
                      ">
                      <p class="error">La fecha es obligatoria</p>
                    </div>
                    <div
                      *ngIf="
                        reactiveForm
                          .get('temporaryUnlockedUntil')
                          .hasError('invalidBusinessDay')
                      ">
                      <p class="error">
                        Por favor, seleccione una fecha dentro de los próximos 7
                        días.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xs-12">
                <div class="form-group">
                  <label class="">
                    {{ 'mlUnlockTemporarilyComponent_REASON_UNLOCK' | i18n }}
                    <span class="tl span-required" title="CAMPO OBLIGATORIO">
                      (*)</span
                    >
                  </label>
                  <textarea
                    name="unlockReason"
                    type="text"
                    class="form-control w-full"
                    [maxLength]="800"
                    formControlName="unlockReason">
                  </textarea>
                  <div
                    *ngIf="
                      reactiveForm.get('unlockReason').invalid &&
                      reactiveForm.get('unlockReason').touched
                    ">
                    <p class="error">La razón del desbloqueo es obligatorio</p>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <ng-template #labelBlock>
            <h3>
              {{ 'mlUnlockTemporarilyComponent_REVERT_UNLOCK_TEXT' | i18n }}
            </h3>
          </ng-template>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-success"
          (click)="confirmSwitchUnlock()">
          {{ 'BTN_LABEL_ACCEPT' | i18n }}
        </button>

        <button
          type="button"
          class="btn btn-default"
          (click)="unlockModal.hide()">
          {{ 'BTN_LABEL_NO_CANCELAR' | i18n }}
        </button>
      </div>
    </div>
  </div>
</div>
